/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ref_N1Inputs */

const en_sorter_ref_n1 = /** @type {(inputs: Sorter_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byte order would give Beta, alpha. Letters outrank case here.`)
};

const ko_sorter_ref_n1 = /** @type {(inputs: Sorter_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`바이트 순이라면 Beta, alpha가 됩니다. 여기서는 글자가 대소문자보다 우선합니다.`)
};

const ja_sorter_ref_n1 = /** @type {(inputs: Sorter_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイト順なら Beta, alpha になります。ここでは文字が大文字小文字より優先します。`)
};

/**
* | output |
* | --- |
* | "Byte order would give Beta, alpha. Letters outrank case here." |
*
* @param {Sorter_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ref_n1 = /** @type {((inputs?: Sorter_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ref_n1(inputs)
	if (locale === "ko") return ko_sorter_ref_n1(inputs)
	return ja_sorter_ref_n1(inputs)
});